export const GET_AWS_ALL_RESOURCE_ALERTS = "GET_AWS_ALL_RESOURCE_ALERTS";
export const GET_AWS_ALL_RESOURCE_ALERTS_SUCCESS = "GET_AWS_ALL_RESOURCE_ALERTS_SUCCESS";
export const GET_AWS_ALL_RESOURCE_ALERTS_FAIL = "GET_AWS_ALL_RESOURCE_ALERTS_FAIL";
export const GET_AWS_ALL_RESOURCE_ALERTS_PAGE = "GET_AWS_ALL_RESOURCE_ALERTS_PAGE";
export const GET_AWS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS = "GET_AWS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS";
export const GET_AWS_ALL_RESOURCE_ALERTS_PAGE_FAIL = "GET_AWS_ALL_RESOURCE_ALERTS_PAGE_FAIL";
export const GET_AWS_ALL_RESOURCE_COUNT = "GET_AWS_ALL_RESOURCE_COUNT";
export const GET_AWS_ALL_RESOURCE_COUNT_SUCCESS = "GET_AWS_ALL_RESOURCE_COUNT_SUCCESS";
export const GET_AWS_ALL_RESOURCE_COUNT_FAIL = "GET_AWS_ALL_RESOURCE_COUNT_FAIL";
export const GET_ALL_ORG_AWS_RESOURCE_TYPES = "GET_ALL_ORG_AWS_RESOURCE_TYPES";
export const GET_ALL_ORG_AWS_RESOURCE_TYPES_SUCCESS = "GET_ALL_ORG_AWS_RESOURCE_TYPES_SUCCESS";
export const GET_ALL_ORG_AWS_RESOURCE_TYPES_FAIL = "GET_ALL_ORG_AWS_RESOURCE_TYPES_FAIL";
export const GET_CLOUD_RESOURCES_SUCCESS = "GET_CLOUD_RESOURCES_SUCCESS";
export const GET_CLOUD_RESOURCES_FAIL = "GET_CLOUD_RESOURCES_FAIL";
export const GET_CLOUD_RESOURCES = "GET_CLOUD_RESOURCES";
export const POST_RESOURCE_OPSGENIE_TEAM_MAPPING = "POST_RESOURCE_OPSGENIE_TEAM_MAPPING";
export const POST_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS = "POST_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS";
export const POST_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL = "POST_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL";
export const POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING = "POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING";
export const POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS = "POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS";
export const POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL = "POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL";
export const POST_UPDATE_RESOURCE_ENVIRONMENT = "POST_UPDATE_RESOURCE_ENVIRONMENT";
export const POST_UPDATE_RESOURCE_ENVIRONMENT_SUCCESS = "POST_UPDATE_RESOURCE_ENVIRONMENT_SUCCESS";
export const POST_UPDATE_RESOURCE_ENVIRONMENT_FAIL = "POST_UPDATE_RESOURCE_ENVIRONMENT_FAIL";
export const POST_RESOURCE_SERVICE_MAPPING = "POST_RESOURCE_SERVICE_MAPPING";
export const POST_RESOURCE_SERVICE_MAPPING_SUCCESS = "POST_RESOURCE_SERVICE_MAPPING_SUCCESS";
export const POST_RESOURCE_SERVICE_MAPPING_FAIL = "POST_RESOURCE_SERVICE_MAPPING_FAIL";

export const GET_AWS_APPSYNC_DATA_SOURCES_ALERTS = "GET_AWS_APPSYNC_DATA_SOURCES_ALERTS";
export const GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_SUCCESS = "GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_SUCCESS";
export const GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_FAIL = "GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_FAIL";

export const GET_AWS_APPSYNC_DATA_SOURCES_COUNT = "GET_AWS_APPSYNC_DATA_SOURCES_COUNT";
export const GET_AWS_APPSYNC_DATA_SOURCES_COUNT_SUCCESS = "GET_AWS_APPSYNC_DATA_SOURCES_COUNT_SUCCESS";
export const GET_AWS_APPSYNC_DATA_SOURCES_COUNT_FAIL = "GET_AWS_APPSYNC_DATA_SOURCES_COUNT_FAIL";

export const GET_AWS_APPSYNC_RESOLVERS_ALERTS = "GET_AWS_APPSYNC_RESOLVERS_ALERTS";
export const GET_AWS_APPSYNC_RESOLVERS_ALERTS_SUCCESS = "GET_AWS_APPSYNC_RESOLVERS_ALERTS_SUCCESS";
export const GET_AWS_APPSYNC_RESOLVERS_ALERTS_FAIL = "GET_AWS_APPSYNC_RESOLVERS_ALERTS_FAIL";

export const GET_AWS_APPSYNC_RESOLVERS_COUNT = "GET_AWS_APPSYNC_RESOLVERS_COUNT";
export const GET_AWS_APPSYNC_RESOLVERS_COUNT_SUCCESS = "GET_AWS_APPSYNC_RESOLVERS_COUNT_SUCCESS";
export const GET_AWS_APPSYNC_RESOLVERS_COUNT_FAIL = "GET_AWS_APPSYNC_DATA_SOURCES_COUNT_FAIL";

export const GET_USER_RESCAN_STATUS = "GET_USER_RESCAN_STATUS";
export const GET_USER_RESCAN_STATUS_SUCCESS = "GET_USER_RESCAN_STATUS_SUCCESS";
export const GET_USER_RESCAN_STATUS_FAIL = "GET_USER_RESCAN_STATUS_FAIL";

